import { api } from '../../../shared/lib/axios';

export interface Role {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  isActive: boolean;
  userCount: number;
  activeUserCount: number;
  permissionCount: number;
}

export interface FeaturePermission {
  featureId: string;
  key: string;
  label: string;
  module: string;
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface RoleMatrix {
  role: { id: string; slug: string; name: string; isSystem: boolean; isActive: boolean };
  features: FeaturePermission[];
}

export const PERFIS_KEYS = {
  all: ['perfis'] as const,
  list: () => ['perfis', 'list'] as const,
  matrix: (roleId: string) => ['perfis', 'matrix', roleId] as const,
};

export async function listarPerfis(): Promise<Role[]> {
  const { data } = await api.get<{ data: Role[] }>('/roles');
  return data.data;
}

export async function buscarMatriz(roleId: string): Promise<RoleMatrix> {
  const { data } = await api.get<{ data: RoleMatrix }>(`/roles/${roleId}/permissions`);
  return data.data;
}

export interface CriarPerfilPayload {
  name: string;
  description?: string;
}

export async function criarPerfil(payload: CriarPerfilPayload): Promise<Role> {
  const { data } = await api.post<{ data: Role }>('/roles', payload);
  return data.data;
}

export interface AtualizarPerfilPayload {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export async function atualizarPerfil(id: string, payload: AtualizarPerfilPayload): Promise<Role> {
  const { data } = await api.patch<{ data: Role }>(`/roles/${id}`, payload);
  return data.data;
}

export async function excluirPerfil(id: string): Promise<void> {
  await api.delete(`/roles/${id}`);
}

export type PermissionPatch = Pick<
  FeaturePermission,
  'featureId' | 'canView' | 'canCreate' | 'canEdit' | 'canDelete'
>;

export async function salvarMatriz(roleId: string, permissions: PermissionPatch[]): Promise<RoleMatrix> {
  const { data } = await api.put<{ data: RoleMatrix }>(`/roles/${roleId}/permissions`, { permissions });
  return data.data;
}
